import { getTeamDisplay } from "../../functionsSimulator";
import bracketBg from "../../../../assets/historia-mundial.jpg";
import "./shareImage.sass";

import fMEX from "../../../../assets/share_MEX.png";
import fZAF from "../../../../assets/share_ZAF.png";
import fKOR from "../../../../assets/share_KOR.png";
import fFIF from "../../../../assets/share_FIFA.png";
import fCAN from "../../../../assets/share_CAN.png";
import fQAT from "../../../../assets/share_QAT.png";
import fSUI from "../../../../assets/share_SUI.png";
import fBRA from "../../../../assets/share_BRA.png";
import fMAR from "../../../../assets/share_MAR.png";
import fHAI from "../../../../assets/share_HAI.png";
import fSCO from "../../../../assets/share_SCO.png";
import fUSA from "../../../../assets/share_USA.png";
import fAUS from "../../../../assets/share_AUS.png";
import fPAR from "../../../../assets/share_PAR.png";
import fGER from "../../../../assets/share_GER.png";
import fECU from "../../../../assets/share_ECU.png";
import fCIV from "../../../../assets/share_CIV.png";
import fCUW from "../../../../assets/share_CUW.png";
import fNED from "../../../../assets/share_NED.png";
import fJPN from "../../../../assets/share_JPN.png";
import fTUN from "../../../../assets/share_TUN.png";
import fBEL from "../../../../assets/share_BEL.png";
import fIRN from "../../../../assets/share_IRN.png";
import fEGY from "../../../../assets/share_EGY.png";
import fNZL from "../../../../assets/share_NZL.png";
import fESP from "../../../../assets/share_ESP.png";
import fURU from "../../../../assets/share_URU.png";
import fKSA from "../../../../assets/share_KSA.png";
import fCPV from "../../../../assets/share_CPV.png";
import fFRA from "../../../../assets/share_FRA.png";
import fSEN from "../../../../assets/share_SEN.png";
import fNOR from "../../../../assets/share_NOR.png";
import fARG from "../../../../assets/share_ARG.png";
import fAUT from "../../../../assets/share_AUT.png";
import fALG from "../../../../assets/share_ALG.png";
import fJOR from "../../../../assets/share_JOR.png";
import fPOR from "../../../../assets/share_POR.png";
import fCOL from "../../../../assets/share_COL.png";
import fUZB from "../../../../assets/share_UZB.png";
import fENG from "../../../../assets/share_ENG.png";
import fCRO from "../../../../assets/share_CRO.png";
import fPAN from "../../../../assets/share_PAN.png";
import fGHA from "../../../../assets/share_GHA.png";
import fBIH from "../../../../assets/share_BIH.png";
import fSWE from "../../../../assets/share_SWE.png";
import fIRQ from "../../../../assets/share_IRQ.png";
import fTUR from "../../../../assets/share_TUR.png";
import fCOD from "../../../../assets/share_COD.png";
import fCZE from "../../../../assets/share_CZE.png";

const FLAGS = {
  MEX: fMEX, ZAF: fZAF, KOR: fKOR, UE2: fFIF, CAN: fCAN, UE3: fFIF,
  QAT: fQAT, SUI: fSUI, BRA: fBRA, MAR: fMAR, HAI: fHAI, SCO: fSCO,
  USA: fUSA, AUS: fAUS, PAR: fPAR, UE1: fFIF, GER: fGER, ECU: fECU,
  CIV: fCIV, CUW: fCUW, NED: fNED, JPN: fJPN, TUN: fTUN, UE4: fFIF,
  BEL: fBEL, IRN: fIRN, EGY: fEGY, NZL: fNZL, ESP: fESP, URU: fURU,
  KSA: fKSA, CPV: fCPV, FRA: fFRA, SEN: fSEN, NOR: fNOR, IC1: fFIF,
  ARG: fARG, AUT: fAUT, ALG: fALG, JOR: fJOR, POR: fPOR, COL: fCOL,
  UZB: fUZB, IC2: fFIF, ENG: fENG, CRO: fCRO, PAN: fPAN, GHA: fGHA,
  BIH: fBIH, SWE: fSWE, IRQ: fIRQ, TUR: fTUR, COD: fCOD, CZE: fCZE 
};

function FlagImg({ flag, className = "" }) {
  const src = FLAGS[flag];
  if (!src) return <div className={`SI-FlagEmpty ${className}`} />;
  return <img src={src} alt={flag} className={`SI-FlagImg ${className}`} />;
}

function TeamSlot({ teamName, isWinner, isLoser }) {
  const team = getTeamDisplay(teamName);
  const cls = ["SI-Team", isWinner && "si-winner", isLoser && "si-loser", team.isPlaceholder && "si-placeholder"]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls}>
      <FlagImg flag={team.flag} />
    </div>
  );
}

// Partido horizontal: home y away lado a lado (Final)
// Partido vertical: home arriba, away abajo (octavos, cuartos, semifinales)
function MatchSlot({ match, top, left, align = "left", gap}) {
  if (!match) return null;
  const isHomeWinner = match.winner === match.home;
  const isAwayWinner = match.winner === match.away;
  const cls = align === "row"
  ? `SI-MatchSlotRow ${isHomeWinner ? "si-home-wins" : ""} ${isAwayWinner ? "si-away-wins" : ""}`.trim()
  : `SI-MatchSlot si-align-${align}`;

  return (
    <div className={cls} style={{ top, left, ...(gap && { gap }) }}>
      <TeamSlot teamName={match.home} isWinner={isHomeWinner} isLoser={isAwayWinner} />
      <TeamSlot teamName={match.away} isWinner={isAwayWinner} isLoser={isHomeWinner} />
    </div>
  );
}

function ChampionSlot({ winner, top, left }) {
  const hasWinner = winner && winner !== "TBD";
  const flag = hasWinner ? getTeamDisplay(winner).flag : null;
  return (
    <div className="SI-ChampionSlot" style={{ top, left }}>
      <FlagImg flag={flag} className="SI-ChampionFlagImg" />
    </div>
  );
}

// ─── Componente principal ─────────────────────────────────────────────────────
export default function ShareImage({ qualifyingState }) {
  const r16 = qualifyingState?.roundOf16 || [];
  const r8 = qualifyingState?.roundOf8 || [];
  const sf = qualifyingState?.semiFinals || [];
  const winner = qualifyingState?.final?.[0]?.winner;

  const byMn = (arr, mn) => arr.find(m => m.matchNumber === mn) || null;
  
  const r16L = [byMn(r16, 89), byMn(r16, 90), byMn(r16, 93), byMn(r16, 94)];
  const r16R = [byMn(r16,92), byMn(r16, 91), byMn(r16, 95), byMn(r16, 96)];
  const r8L = [byMn(r8, 97), byMn(r8, 98)]; 
  const r8R = [byMn(r8, 99), byMn(r8, 100)];
  const sfL = byMn(sf, 101);
  const sfR = byMn(sf, 102);
  const fin104 = byMn(qualifyingState?.final || [], 104);

  // ── Coordenadas absolutas en px (canvas 1080×1920) ──────────────────────────
  const r16LeftTops = [480, 749, 1007, 1276];
  const r16RightTops = [479, 749, 1007, 1276];
  const r16LeftLeft = 73;
  const r16RightLeft = 935;

  const r8LeftTops = [614, 1141];
  const r8RightTops = [614, 1141];
  const r8LeftLeft = 213;
  const r8RightLeft = 795;

  const sfLeftTop = 879;
  const sfRightTop = 876;
  const sfLeftLeft = 304;
  const sfRightLeft = 705;

  // Final (partido 104)
  const finalTop = 924;
  const finalLeft = 457;
  // campeón
  const champTop = 475;
  const champLeft = 540;

  const rootStyle = { backgroundImage: `url(${bracketBg})` }

  return (
    <div className="SI-Root" aria-hidden="true" style={rootStyle}>

      {r16L.map((m, i) => (
        <MatchSlot key={m?.id ?? `r16l${i}`} match={m} top={r16LeftTops[i]} left={r16LeftLeft} align="left" />
      ))}
      {r16R.map((m, i) => (
        <MatchSlot key={m?.id ?? `r16r${i}`} match={m} top={r16RightTops[i]} left={r16RightLeft} align="right" />
      ))}

      {r8L.map((m, i) => (
        <MatchSlot key={m?.id ?? `r8l${i}`} match={m} top={r8LeftTops[i]} left={r8LeftLeft} align="left" />
      ))}
      {r8R.map((m, i) => (
        <MatchSlot key={m?.id ?? `r8r${i}`} match={m} top={r8RightTops[i]} left={r8RightLeft} align="right" />
      ))}

      {sfL && <MatchSlot match={sfL} top={sfLeftTop} left={sfLeftLeft} align="left" />}
      {sfR && <MatchSlot match={sfR} top={sfRightTop} left={sfRightLeft} align="right" />}

      <ChampionSlot winner={winner} top={champTop} left={champLeft} />

      {fin104 && <MatchSlot match={fin104} top={finalTop} left={finalLeft} align="row" gap={'21px'} />}

    </div>
  );
}